'use client';
import { createCtx } from '~/utils/context';
import type { PublicConfig } from '../modules/ui/public-config';

export const [usePublicConfig, PublicConfigProvider] =
  createCtx<PublicConfig>();
